import React from 'react'
import classnames from 'classnames'

import { Item } from '../../../core/items'
import {
  getFeatureDisplayName,
  getFeatureDisplayContent,
} from '../../../core/i18n'
import { SupportedLanguageCode } from '../../../core/i18n'
import { strings } from './each-item-content'
import styles from '../../styles/modules/table.module.scss'

interface Props {
  item: Item
  activeLanguage: SupportedLanguageCode
}

const FeaturesTable: React.FC<Props> = props => {
  const { activeLanguage } = props

  return (
    <div
      className={classnames({
        [styles.wrapper]: true,
        [styles.stocker]: true,
      })}
    >
      <table className={`${styles.container} ${styles.featuresTableDetail}`}>
        <tbody>
          {props.item.features.map((elem, index) => (
            <tr
              className={styles.rowStatic}
              key={`feature-${activeLanguage}-${index}`}
            >
              <td className={styles.cell}>
                {getFeatureDisplayName(elem, activeLanguage) || strings.notSet}
              </td>
              <td className={styles.cell}>
                {getFeatureDisplayContent(elem, activeLanguage) ||
                  strings.notSet}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default FeaturesTable
